import React from 'react'
import { BrandLogo } from '../brand/BrandLogo'
import { PillButton } from '../actions/PillButton'
import { BadgeChip } from '../editorial/BadgeChip'

export interface HeaderStudioProps {
  completedCount: number
  totalCount: number
  storageUsage: { usage: number; quota: number }
  isExportingZip: boolean
  onExportZip: () => void
  onClearSession: () => void
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export const HeaderStudio: React.FC<HeaderStudioProps> = ({
  completedCount,
  totalCount,
  storageUsage,
  isExportingZip,
  onExportZip,
  onClearSession,
}) => {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '20px',
        padding: '24px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        marginBottom: '32px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <BrandLogo size="160px" tagline subtitle="LOCAL-FIRST MEDIA STUDIO" />
        <BadgeChip variant="pulse" icon="pi-shield">
          100% LOCAL · PRIVACIDAD ABSOLUTA
        </BadgeChip>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        {storageUsage.quota > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              paddingRight: '12px',
              borderRight: '1px solid rgba(255, 255, 255, 0.08)',
            }}
          >
            <span
              style={{
                fontSize: '11px',
                color: 'rgba(255, 255, 255, 0.45)',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
              }}
            >
              OPFS Almacenamiento
            </span>
            <span
              className="tabular-nums"
              style={{
                fontSize: '13px',
                color: 'rgba(255, 255, 255, 0.85)',
                fontWeight: 600,
              }}
            >
              {formatBytes(storageUsage.usage)}{' '}
              <span style={{ color: 'rgba(255, 255, 255, 0.4)' }}>
                / {formatBytes(storageUsage.quota)}
              </span>
            </span>
          </div>
        )}

        {totalCount > 0 && (
          <PillButton
            label="Limpiar Sesión"
            variant="ghost"
            size="md"
            icon="pi-trash"
            onClick={onClearSession}
          />
        )}

        <PillButton
          label={`Descargar Todo (${completedCount})`}
          variant="solid"
          size="md"
          icon="pi-download"
          badgeIcon="pi-arrow-down"
          loading={isExportingZip}
          disabled={completedCount === 0 || isExportingZip}
          onClick={onExportZip}
        />
      </div>
    </header>
  )
}
